// extracted by mini-css-extract-plugin
export var header = "_ws-1";
export var maskBottom = "_ws-6";
export var maskMiddle = "_ws-7";
export var maskTop = "_ws-5";
export var root = "_ws-0";
export var scrollDownButton = "_ws-3";
export var scrollDownButtonHidden = "_ws-4";
export var viewport = "_ws-2";